<template>
  <div class="banner-page">
    <div class="banner-wrap">
      <div class="banner-detail" v-if="indexBannerList.length>0">
        <swiper @click.native="indexBannerGoHref" ref="mySwiper" class="custom-swiper-wrap custom-swiper-pagination"
          :options="swiperOption">
          <swiper-slide v-for="(item,index) in indexBannerList" class="swiper-slide-item" :key="index">
            <img style="cursor: pointer" :src="item.imgLink" alt width="100%">
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
    </div>
    <div class="marquee-wrap" v-if="isShowBanner">
      <my-marquee></my-marquee>
    </div>
    <!-- <div class="marquee-bottom" @mouseover="demo1=!demo1" @mouseout="demo1=!demo1">
      <VTextMarquee :speed="40" :content="list.join(' ')" :animate="demo1"></VTextMarquee>
    </div> -->
  </div>
</template>
<script>
  import { mapState } from "vuex";
  import myMarquee from '../common/marquee/marquee-news';
  import { VTextMarquee } from 'vue-text-marquee';
  import {
    swiper,
    swiperSlide
  } from 'vue-awesome-swiper';
  import 'swiper/dist/css/swiper.css';
  import {
    bannerCodeImg
  } from '@/common/mixins'

  export default {
    name: 'game-header',
    mixins: [bannerCodeImg],
    components: {
      myMarquee,
      swiper,
      swiperSlide,
      VTextMarquee,
    },
    props: {
      isShowBanner: {
        default: false,
        type: Boolean
      },
      bannerCode: {
        default: '',
        type: String
      }
    },
    created() {
      setTimeout(() => {
        this.list = ['Vue (读音 /vjuː/，类似于 view) 是', '一套用于构建用户界面的渐进式框架'];
      }, 1000);
    },
    computed:{
    ...mapState({
        isLogin: (state) => state.isLogin,
      }),
    },
    data() {
      return {
        demo1:true,
        swiperOption: {
          loop: true,
          lazyLoading : true,  //启动延迟加载
      　　lazyLoadingInPrevNext : true,      //延迟加载应用到最接近的slide的图片
      　　lazyLoadingInPrevNextAmount : 1,   //加载下一个slide
      　　lazyLoadingOnTransitionStart : true,  //过渡到slide一开始就加载，设置为true
          // effect: 'fade',
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
            renderBullet(index, className) {
              return `<span class="${className} swiper-pagination-bullet-custom"></span>`
            }
          },
          autoplay: {
            delay: 4000,
            autoplayDisableOnInteraction: false
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }
        },
        list:[]
      }
    }
  };
</script>

<style scoped lang="scss">
  .banner-page {
    margin-top:100px;
    .banner-wrap {
      width: 100%;
      position: relative;
      z-index: 1;
      .banner-detail {
        .custom-swiper-wrap {
          width: 100%;
          .swiper-slide-item {
            position: relative;
            width:100%!important;
            img { width: 100%; height:auto; }
          }
        }
      }
    }
    .marquee-wrap{width: 1100px; margin: 20px auto 40px;}
  }
</style>



// WEBPACK FOOTER //
// src/pages/build901/components/game-header/game-header.vue